module.exports = __webpack_public_path__ + "media/KamereoV2.351cdf84.svg";